import { defineComponent as _defineComponent } from 'vue'
import ApplyStageLabelIcon from '../../../common/icons/ApplyStageLabelIcon.vue';
import useMasterApplyControl from '../../../../hooks/useMasterApplyControl';
import Avatar from '../../../common/Avatar.vue';
import Dialog from '../../../common/base/Dialog';
import SvgIcon from '../../../common/base/SvgIcon.vue';
import TuiButton from '../../../common/base/Button.vue';
import { roomService } from '../../../../services';


export default /*#__PURE__*/_defineComponent({
  __name: 'MasterApplyControlPC',
  setup(__props) {

const {
  t,
  showApplyUserList,
  hideApplyList,
  applyToAnchorUserCount,
  applyToAnchorList,
  handleAllUserApply,
  handleUserApply,
} = useMasterApplyControl();

return { __sfc: true,t, showApplyUserList, hideApplyList, applyToAnchorUserCount, applyToAnchorList, handleAllUserApply, handleUserApply, ApplyStageLabelIcon, Avatar, Dialog, SvgIcon, TuiButton, roomService }
}

})